import React from 'react';
import './Page.css';

export const Page: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className="da-page">{children}</div>;
};
